import { randomstring } from '@/utilities/utils';
import { DropdownItemBase } from './DropdownItemBase';
import type { Ref } from 'vue';

export class DropdownItemSeparator extends DropdownItemBase {
    private abuseBlocker = null;

    private guid: string;

    private constructor(hideDropDownItem: Ref<boolean> | undefined = undefined, uniqueLoopKey: string = randomstring('')) {
        super();
        this.guid = uniqueLoopKey;
        this.hideDropDownItem = hideDropDownItem;
    }

    get uniqueLoopKey() {
        return this.guid;
    }

    public static create(options?: Partial<Pick<DropdownItemBase, 'hideDropDownItem' | 'uniqueLoopKey'>>): DropdownItemSeparator {
        return new DropdownItemSeparator(options?.hideDropDownItem, options?.uniqueLoopKey);
    }
}
